/* eslint-disable array-element-newline */
import {LitElement, html} from 'lit';
import styles from './diamond-preview-carat-slider.component.scss?as=stylesheet';
import previewStyles from './diamond-preview.component.scss?as=stylesheet';
import {DIAMOND_PREVIEW_MIN_CARAT, DIAMOND_PREVIEW_MAX_CARAT} from 'extensions/ring-builder/data/constants';
import {defineCustomElement} from 'extensions/utils';

class DiamondPreviewCaratSlider extends LitElement {

	static get styles () {
		return [styles, previewStyles];
	}

	static get properties () {
		return {
			carat: Number,
			max: Number,
			min: Number,
			step: Number
		};
	}

	constructor () {
		super();

		this.min = DIAMOND_PREVIEW_MIN_CARAT || 0.5;
		this.max = DIAMOND_PREVIEW_MAX_CARAT || 2.5;
		this.step = 0.25;
		this.carat = this.min;
	}

	/**
	 * Generate array of carat values for buttons
	 */
	get caratOptions () {
		const options = [];
		const min = Number(this.min);
		const max = Number(this.max);
		const step = Number(this.step);

		for (let i = 0; min + (i * step) <= max; i++) {
			const value = min + (i * step);
			options.push(Number(value.toFixed(2)));
		}
		return options;
	}

	/**
	 * Handle button click to change carat value
	 */
	handleCaratChange (event) {
		const newCarat = parseFloat(event.target.dataset.carat);

		if (this.carat !== newCarat) {
			this.carat = newCarat;
			this.dispatchEvent(new Event('change'));
		}
	}

	render () {
		return html`
			<div class="diamond-preview">
				<div class="diamond-preview--label">
					<div class="diamond-preview-title">Carat Weight Total:</div>
					<div class="diamond-preview-selection">${this.carat} Carat</div>
				</div>
				<div class="diamond-carats">
					<div class="diamond-carats-buttons">
						${this.caratOptions.map(caratValue => html`
							<button
								class="diamond-carat-button ${Number(this.carat) === Number(caratValue) ? 'active' : ''}"
								data-carat="${caratValue}"
								@click="${this.handleCaratChange}"
								aria-label="${caratValue} Carat"
							>
								${caratValue}
							</button>
						`)}
					</div>
				</div>
			</div>
		`;
	}

};

defineCustomElement('rb-diamond-preview-carat-slider', DiamondPreviewCaratSlider);
